import React, { Component } from "react";
import { CheckUser, Usernotification, RemoveNoti } from "../../Model/Users";
import { VirsionCheck } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons, withRouter } from "../../Helpers/Common";
import { Link } from 'react-router-dom';
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Notifcationdesk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            VirsionCheckData: false,
            VirsionCheckDataloaded: false,
            NotifcationData: false,
            Notaction: false,
            SelectedNot: false,
            updatenotification: false
        };
    }

    componentDidMount() {
        CheckUser().then((checkuserstatus) => {
            if (checkuserstatus == null) {
                this.props.navigate("/createaccount");
            } else {
                Usernotification().then((usernotification) => {
                    this.setState({
                        VirsionCheckDataloaded: true,
                        NotifcationData: usernotification,
                    });
                });

            }
        });
    }

    formatAMPM = (date) => {
        var ss = new Date(date).toDateString();
        return ss;
    };

    NotActionpopup(index) {
        var Allnotification = this.state.NotifcationData.data.notifications[index];
        this.setState({
            Notaction: true,
            SelectedNot: Allnotification,
            indexSel: index
        });
    }

    closemodel() {
        this.setState({
            Notaction: false,
            SelectedNot: false
        });
    }
    removenoti(id, index) {
        //document.getElementById("not" + id).remove(); 
        var postData = {
            notification_id: id,
            status: "Inative"
        }
        RemoveNoti(postData).then((resp) => {
            var Resp = JSON.parse(resp.data);
            if (Resp.success == true) {
                if (document.getElementById("not" + id) !== null) {
                    Usernotification().then((usernotification) => {
                        this.setState({
                            updatenotification: usernotification,
                        });
                    });
                }
            }
        })
    }
    

    render() {
        if (this.state.VirsionCheckDataloaded == false || this.state.NotifcationData == false) {
            // return <div className="loader"></div>;
            return <div className="loader"><BarLoader color="#ff000f" /></div>;
        } else {
            if (this.state.updatenotification) {
                this.state.NotifcationData = this.state.updatenotification
            }
            if (this.state.NotifcationData.data.errorcode == 1152) {
                return (
                    <>
                        <div className="mb-0 dD-block">
                            <div className="notification-message-desk"><p>{this.state.NotifcationData.data.message.split('\n')[0]} <span>{this.state.NotifcationData.data.message.split('\n')[1]}</span></p></div>
                        </div>
                    </>
                );
            } else {
                return (
                    <>
                        <div className="mb-0 dD-block">
                            {this.state.NotifcationData.data.notifications.map(
                                (NotiData, index) => {
                                    if (NotiData.notification_type === "Manage Membership") {
                                        var link = "/manage-membership";
                                    } else if (NotiData.notification_type === "Manage Profile") {
                                        var link = "/profile";
                                    } else if (NotiData.notification_type === "Plan Detail") {
                                        var link = "/become-a-member";
                                    } else {
                                        var link = "/profile";
                                    }
                                    return (
                                        <div className="notification-inn" key={"not" + NotiData.ID} id={"not" + NotiData.ID}>
                                            <Link to={link} >
                                                <div className="rdot" />
                                                <div className="noti-left-content">
                                                    <img src={NotiData.image} alt="DocuBay" />
                                                    <div className="notification-right">
                                                        <h5>{NotiData.notification_type}</h5>
                                                        <h6>{NotiData.description}</h6>
                                                        <h6>{this.formatAMPM(NotiData.modified_on)}</h6>
                                                    </div>
                                                </div>
                                            </Link>
                                            <div className="tdot bannerpop-modal-toggle">
                                                <img src={ImageData['Delete-Icon-1.png']} alt="DocuBay" onClick={() => {
                                                    this.removenoti(NotiData.ID, index);
                                                }} />
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    </>
                );
            }
        }
    }
}
export default withRouter(Notifcationdesk);
